module.exports = __webpack_public_path__ + "img/QRcode (2).d78aee1b.png";